<template>
  <b-form-group v-bind:class="{disabled: item.disabled}">
    <b-form-checkbox v-model="item.value" :disabled="item.disabled" v-on:input="change">
      {{item.field.prompt}}
    </b-form-checkbox>
  </b-form-group>
</template>


<script>

export default {
  name: 'CheckField',
  props: {
    item: { type: Object }
  },
  computed: {
  },
  methods: {
    change (newValue) {
      this.$emit('change', {fieldName: this.item.field.field_name, checkValue: this.item.field.check_value, value: this.item.value})
    },
    validate () {
      return true
    },
    value () {
      if (this.item.value) {
        return { field_name: this.item.field.field_name, string_value: this.item.field.check_value }
      } else {
        return null
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/data_entry/CheckField.vue